import { combineReducers } from 'redux'
import { useSelector, shallowEqual } from 'react-redux';

import callbacks from './callbacks';
import campaigns from './campaigns';
import login from './login';
import supportRecords from './supportRecords';
import supporters from './supporters';
import todos from './todos';
import stats from './stats';
import organizations from './organizations';

const RootReducer = combineReducers({
    callbacks,
    campaigns,
    login,
    supportRecords,
    supporters,
    todos,
    stats,
    organizations
});

/**
 * Helper function for wrapping a selector with a shallowEqual equality function
 */
export const useShallowEqualSelector = (selector) => {
    return useSelector(selector, shallowEqual);
};


export default RootReducer;